// KB shortcuts applicable on Goal/KR/Initiative
import initiativeKeymaps from '@/services/keymapService/initiativeKeyMaps'

const entityShortcuts = [
  { name: 'previous-item', description: 'Go to previous goal' },
  { name: 'next-item', description: 'Go to next goal' },
  { name: 'expand-item', description: 'Expand the currently selected goal' },
  { name: 'collapse-item', description: 'Collapse the currently selected goal' },
  { name: 'toggle-expansion', description: 'Expand/Collapse selected goal' },
  { name: 'open', description: 'Open Selected item page' },
  { name: 'edit-item', description: 'Edit the currently selected goal' },
  { name: 'checkin', description: 'Checkin the selected KR / Mark initiative/task done/undone' },
  { name: 'cancel-editing', description: 'Cancel editing' },
  { name: 'add-initiative', description: 'Add an initiative to selected KR' },
  { name: 'comment', description: 'Comment' },
  { name: 'delete-initiative', description: 'Delete selected initiative' }
]

export default {
  global: {
    name: 'global',
    description: 'Global',
    actions: [
      { name: 'view-shortcuts', description: 'View shortcuts' },
      { name: 'open-search', description: 'Search' },
      { name: 'profile-menu', description: 'Show the profile menu' },
      { name: 'escape', description: 'Escape', shouldList: false },
      { name: 'quick-add-initiative', description: 'Add an Initiative' },
      { name: 'navigate-to-your-goals', description: 'Go to Your Work page' },
      { name: 'navigate-to-org-goals', description: 'Go to Your Org Goals page' },
      { name: 'submit-form', description: 'Submit the form' },
      { name: 'navigate-to-previous-page', description: 'Go to previous page' }
    ]
  },
  inbox: {
    name: 'inbox',
    description: 'Inbox',
    actions: [
      { name: 'open-inbox', description: 'Open notifications inbox' },
      { name: 'close-inbox', description: 'Close notifications inbox' }
    ]
  },
  archives: {
    name: 'archives',
    description: 'Archives',
    actions: entityShortcuts
  },
  goals: {
    name: 'goals',
    description: 'Goals',
    actions: [...entityShortcuts, { name: 'bulk-checkin', description: 'Go to Beast mode checkin' }]
  },
  ideaLists: {
    name: 'ideaLists',
    description: 'Idea Lists',
    actions: [
      { name: 'previous-item', description: 'Go to previous Item' },
      { name: 'next-item', description: 'Go to next Item' },
      { name: 'expand-item', description: 'Expand the currently selected Item' },
      { name: 'collapse-item', description: 'Collapse the currently selected Item' },
      { name: 'toggle-expansion', description: 'Expand/Collapse selected Item' },
      { name: 'open', description: 'Open Selected item page' },
      { name: 'edit-idea', description: 'Edit the currently selected Item' },
      { name: 'done-undone-item', description: 'Mark idea done/undone' },
      { name: 'cancel-editing', description: 'Cancel editing of Item' },
      { name: 'add-idea', description: 'Add an idea to selected Idea List' },
      { name: 'comment', description: 'Comment' }
    ]
  },
  goal: {
    name: 'goal',
    description: 'Goal',
    actions: [
      { name: 'previous-item', description: 'Go to previous KR or goal' },
      { name: 'next-item', description: 'Go to next KR or goal' },
      { name: 'edit-item', description: 'Edit the selected item' },
      {
        name: 'checkin',
        description: 'Checkin the selected KR or Mark the selected initiative done/not-done'
      },
      { name: 'toggle-expansion', description: 'Expand/Collapse selected item' },
      { name: 'open', description: 'Open Selected item page' },
      { name: 'expand-item', description: 'Expand selected item' },
      { name: 'collapse-item', description: 'Collapse selected item' },
      { name: 'cancel-editing', description: 'Cancel editing of initiative' },
      { name: 'add-initiative', description: 'Add an initiative to selected KR' },
      { name: 'comment', description: 'Comment' }
    ]
  },
  kr: {
    name: 'kr',
    description: 'Initiatives',
    actions: [
      { name: 'previous-item', description: 'Go to previous initiative' },
      { name: 'next-item', description: 'Go to next initiative' },
      { name: 'expand-item', description: 'Expand selected initiative' },
      { name: 'collapse-item', description: 'Collapse selected initiative' },
      { name: 'toggle-expansion', description: 'Expand/Collapse selected initiative' },
      { name: 'open', description: 'Open Selected initiative' },
      { name: 'done-undone-item', description: 'Mark initiative done/undone' },
      { name: 'add-initiative', description: 'Add an initiative' },
      { name: 'edit-initiative', description: 'Edit the currently selected initiative' },
      { name: 'cancel-editing', description: 'Cancel editing of initiative' },
      { name: 'comment', description: 'Comment' },
      { name: 'delete-initiative', description: 'Delete selected initiative' }
    ]
  },
  ideaList: {
    name: 'ideaList',
    description: 'Idea List',
    actions: [
      { name: 'previous-item', description: 'Go to previous idea' },
      { name: 'next-item', description: 'Go to next idea' },
      { name: 'expand-item', description: 'Expand selected idea' },
      { name: 'collapse-item', description: 'Collapse selected idea' },
      { name: 'toggle-expansion', description: 'Expand/Collapse selected idea' },
      { name: 'open', description: 'Open Selected idea' },
      { name: 'done-undone-item', description: 'Mark idea done/undone' },
      { name: 'add-idea', description: 'Add an idea' },
      { name: 'edit-idea', description: 'Edit the currently selected idea' },
      { name: 'cancel-editing', description: 'Cancel editing of idea' },
      { name: 'comment', description: 'Comment' }
    ]
  },
  initiative: {
    name: 'initiative',
    description: 'Initiative',
    actions: [
      { name: 'edit-initiative', description: 'Edit initiative' },
      { name: 'cancel-editing', description: 'Cancel editing of initiative' },
      { name: 'comment', description: 'Comment' },
      { name: 'add-task', description: 'Add a task' },
      { name: 'previous-item', description: 'Go to previous task' },
      { name: 'next-item', description: 'Go to next task' },
      { name: 'open', description: 'Open selected task' },
      { name: 'done-undone-item', description: 'Mark selected task done/undone' },
      { name: 'Ctrl-<delete>', description: 'Delete selected task' }
    ]
  },
  allInitiatives: {
    name: 'allInitiatives',
    description: 'All Initiatives',
    actions: initiativeKeymaps.categoryDefinitions
  },
  initiativesListView: {
    name: 'initiativesListView',
    description: 'Initiatives List View',
    actions: [
      ...initiativeKeymaps.categoryDefinitions,
      { name: 'add-initiative', description: 'Add an initiative' }
    ]
  },
  sidebar: {
    name: 'sidebar',
    description: 'Navigation Sidebar',
    actions: [{ name: 'toggle-sidebar', description: 'Expand/Collapse the sidebar.' }]
  },
  'edit-goal': {
    name: 'edit-goal',
    description: 'Edit Goal',
    actions: [{ name: 'add-kr', description: 'Add KR' }]
  },
  initiativeModal: {
    name: 'initiativeModal',
    description: 'Initiative Modal',
    actions: [
      { name: 'next-initiative', description: 'Go to next initiative' },
      { name: 'previous-initiative', description: 'Go to previous initiative' }
    ]
  },
  ideaModal: {
    name: 'ideaModal',
    description: 'Idea Modal',
    actions: [
      { name: 'next-idea', description: 'Go to next idea' },
      { name: 'previous-idea', description: 'Go to previous idea' }
    ]
  },
  spotlightSearch: {
    name: 'spotlightSearch',
    description: 'Search',
    actions: [
      { name: 'previous-search-item', description: 'Go to previous item' },
      { name: 'next-search-item', description: 'Go to next item' },
      { name: 'view-search-item', description: 'Visit selected item' }
    ]
  },
  myWork: {
    name: 'myWork',
    description: 'My work page',
    actions: [
      { name: 'view-shortcuts', description: 'View shortcuts' },
      { name: 'add-task', description: 'Add a task' },
      ...initiativeKeymaps.categoryDefinitions
    ]
  },
  yourWork: {
    name: 'yourWork',
    description: 'Your work page',
    actions: [
      { name: 'cancel-editing', description: 'Cancel editing' },
      { name: 'bulk-checkin', description: 'Go to Beast mode checkin' }
    ]
  }
}
